import { compose } from '@reduxjs/toolkit';
import { fetchOrderByIdReducer } from './fetch-order-by-id';
import { fetchOrderListReducer } from './fetchOrders';

export const extraReducers = compose(fetchOrderListReducer, fetchOrderByIdReducer);
export { fetchOrderById } from './fetch-order-by-id';
export { fetchOrderList } from './fetchOrders';
